import { Link } from "react-router-dom";

import "./buy-button.scss";

function BuyButton({
  background,
  text,
  icon,
  state,
  onClickCallback,
  disabled = false,
}) {
  const styles = {
    background,
  };

  if (disabled) {
    styles.pointerEvents = "none";
    styles.background = "gray";
  }

  return (
    <div className="d-flex gap-2 w-100 h-100">
      <Link
        className="d-flex justify-content-between px-4 align-items-center w-100 h-100 button"
        style={styles}
        onClick={onClickCallback}
        to={"/carrinho"}
      >
        {icon}
        {text}
      </Link>
      {state === "rented" ? (
        <Link
          className="d-flex justify-content-between px-3 align-items-center w-100 h-100 button"
          style={{ background: "#EEA652" }}
        >
          {icon}
          avise-me quando disponível
        </Link>
      ) : (
        ""
      )}
    </div>
  );
}

export default BuyButton;
